// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"a1162f8b","631":"38554c6e","760":"163f740a","774":"119ed11d","787":"86488061","854":"27088e19"}[chunkId] + ".chunk.js";
};